<div id="pageCloseBtn" *ngIf="!land">
  <span (click)="close()" *ngIf="!formIdTag">×</span>
</div>

<div id="wrap">
  <!--<div id="tab_title">
    <div id="tab_title_1" class="fontSize18" (click)="tabTitleClicked(true)" [ngClass]="{'tab_title_selected':personalUserSelected,'tab_title_not_selected':!personalUserSelected}">
      个人用户
    </div>
    <div id="tab_title_2" class="fontSize18" (click)="tabTitleClicked(false)" [ngClass]="{'tab_title_selected':!personalUserSelected,'tab_title_not_selected':personalUserSelected}">
      企业用户
    </div>
  </div>-->
  <div id="space"></div>
  <form #registerForm="ngForm" class="registerForm">
    <input type="hidden" [(ngModel)]="registerType" name="registerType">
    <div id="tab">
      <div id="tab_1" *ngIf="personalUserSelected">
        <div class="tab_word fontSize14 lineHeight24">
          2018.1.15-2018.2.15期间，申请参加内测活动，可获赠一个免费个人账号。
        </div>
        <div id="tab_1_tel" class="input_wrap">
          <input type="text" placeholder="请输入手机号" maxlength="14" (focus)="onFocus('tab_1_tel_input')" class="input_text fontSize16" data-target="phone" id="tab_1_tel_input" [(ngModel)]="phone_1" name="phone" required />
        </div>
        <p class="validateTxt phoneValidateTxt">请填写手机号码</p>
        <div id="tab_1_verification" class="input_wrap">
          <input type="text" placeholder="请输入验证码" maxlength="6" class="input_text fontSize16" id="tab_1_verification_input" data-target="smsCode" [(ngModel)]="verification_code_1" name="verification_code" required />
          <span id="tab_1_verification_send_out" class="fontSize14 send_out" (click)="sendCode(true)">
            <span class="send_out_word" id="tab_1_verification_send_out_word">发送验证码</span><span class="remainTime" id="tab_1_verification_send_out_remain_time"></span>
          </span>
        </div>
        <p class="validateTxt smsCodeValidateTxt">请填写手机验证码</p>
        <button class="submitBtn fontSize16 lineHeight24" (click)="submitForm(true)" [disabled]="submitButtonDisabled">提交申请</button>
      </div>
      <!--<div id="tab_2" *ngIf="!personalUserSelected">-->
      <div id="tab_2" *ngIf="shenqing">
        <div class="tab_word fontSize13 lineHeight24">
          完整填写以下信息，即可申请企业试用机会。
        </div>
        <div id="tab_2_myname" class="input_wrap">
          <input type="text" placeholder="姓名" id="tab_2_myname_input" class="input_text fontSize16" data-target="username" (focus)="onFocus('tab_2_myname_input')" [(ngModel)]="myname" name="myname" required />
        </div>
        <p class="validateTxt usernameValidateTxt">请填写姓名</p>
        <div id="tab_2_company" class="input_wrap">
          <input type="text" placeholder="请输入公司名称" id="tab_2_company_input" class="input_text fontSize16" (focus)="onFocus('tab_2_company_input')" data-target="companyName" [(ngModel)]="name" name="name" required />
        </div>
        <p class="validateTxt companyNameValidateTxt">请填写公司名称</p>
        <div class="input_wrap" (click)="onScaleClicked()">
          <input type="text" placeholder="请选择公司规模" class="input_text fontSize16" data-target="companySize"  unselectable="on" readonly onfocus="this.blur()" id="tab_2_scale_input" [(ngModel)]="size" name="size" required />
          <span class="fontSize14 send_out">
            <i class="fa fa-caret-down negativeStar"></i>
          </span>
        </div>
        <p class="validateTxt companySizeValidateTxt">请选择公司规模</p>
        <div class="input_wrap" (click)="onPostClicked()">
          <input type="text" placeholder="请选择职务" class="input_text fontSize16" data-target="companyJob" unselectable="on" readonly id="tab_2_post_input" onfocus="this.blur()" [(ngModel)]="title" name="title" required />
          <span class="fontSize14 send_out">
            <i class="fa fa-caret-down negativeStar"></i>
          </span>
        </div>
        <p class="validateTxt companyJobValidateTxt">请选择职务</p>
        <div id="tab_2_registerCode" class="input_wrap" >
          <input type="text" placeholder="请输入邀请码（选填）" id="tab_2_registerCode_input" class="input_text fontSize16" data-target="registerCode" [(ngModel)]="registerCode" name="registerCode" required />
        </div>
        <p class="validateTxt registerCodeValidateTxt">您的邀请码有误/已过期，请重新输入或通过公众号菜单“联系我们”</p>
        <div id="tab_2_tel" class="input_wrap">
          <input type="text" placeholder="请输入手机号" maxlength="14" class="input_text fontSize16"  data-target="phone" id="tab_2_tel_input" (focus)="onFocus('tab_2_tel_input')" [(ngModel)]="phone_2" name="phone" required />
        </div>
        <p class="validateTxt phoneValidateTxt">请填写手机号码</p>
        <div id="tab_2_verification" class="input_wrap">
          <input type="text" placeholder="请输入验证码" maxlength="6"  data-target="smsCode" class="input_text fontSize16" id="tab_2_verification_input"  (focus)="onFocus('tab_2_verification_input')" [(ngModel)]="verification_code_2" name="verification_code" required />
          <span id="tab_2_verification_send_out" class="fontSize14 send_out" (click)="sendCode(false)">
            <span class="send_out_word" id="tab_2_verification_send_out_word">发送验证码</span><span class="remainTime" id="tab_2_verification_send_out_remain_time"></span>
          </span>
        </div>
        <p class="validateTxt smsCodeValidateTxt">请填写手机验证码</p>
        <!--<button id="yishengqing" *ngIf="yishengqing" class="submitBtn fontSize16 lineHeight24" >已申请</button>-->
        <!--<button *ngIf="tijiao" class="submitBtn fontSize16 lineHeight24" (click)="submitForm(false)" [disabled]="submitButtonDisabled">提交申请</button>-->
        <button  class="submitBtn fontSize16 lineHeight24" (click)="submitForm(false)" [disabled]="submitButtonDisabled">提交申请</button>
        <!--<div class="tab_word fontSize13  lineHeight24" *ngIf="tijiao">提交以上申请，我们将在1-2个工作日内联系您</div>-->
      </div>

<!--     <div id="tab_3" *ngIf="land">
        <div class="tab_word fontSize12 lineHeight24" id="title_3">
          如公司已购买账户，请登陆
        </div>
        <div id="tab_1_tel" class="input_wrap">
          <input type="text" placeholder="请输入手机号/邮箱" maxlength="14" (focus)="onFocus('tab_1_tel_input')" class="input_text fontSize16" data-target="phone" id="tab_1_tel_input" (focus)="onFocus('tab_1_tel_input')" [(ngModel)]="phone_1" name="phone" required />
        </div>
        <p class="validateTxt phoneValidateTxt">请填写手机号码</p>
        <div id="tab_1_verification" class="input_wrap">
          <input type="text" placeholder="请输入验证码" maxlength="6" class="input_text fontSize16" id="tab_1_verification_input"   (focus)="onFocus('tab_1_verification_input')" data-target="smsCode" [(ngModel)]="verification_code_1" name="verification_code" required />
          <span id="tab_1_verification_send_out" class="fontSize14 send_out" (click)="sendCode(true)">
            <span class="send_out_word" id="tab_1_verification_send_out_word">发送验证码</span><span class="remainTime" id="tab_1_verification_send_out_remain_time"></span>
          </span>
        </div>
        <p class="validateTxt smsCodeValidateTxt">请填写手机验证码</p>

        <button class="submitBtn_3 fontSize16 lineHeight24" (click)="login()">登录</button>
      </div> -->

			<!-- 2019-9-4 企业员工可以通过员工号密码登录学习 start-->

			<div id="tab_4" *ngIf="land">
<div class="model_bg"></div>
<div class="toset" id="toset_div"></div>
				<div class="model_div"></div>
				<div class="model_div_con numberClass" id="numberId">
          <div class="model_exit" (click)="cancel()">×</div>
					<div class="tab_word fontSize12 lineHeight24">该账号已在其他微信号上登录，如果继续，所有学习数据会被清除，确认继续登陆吗？</div>
					<div class="model_btn clearfix"><button class="submitBtn_4 fontSize16 lineHeight24 fl" (click)="cancel()">退出</button><button class="submitBtn_3 fontSize16 lineHeight24 fr" (click)="loginAgain()">继续登录</button></div>
				</div>

<div class="model_div_con phoneClass" id="phoneId">
	<div class="model_exit" (click)="cancel()">×</div>
	<div class="tab_word fontSize12 lineHeight24">该手机号已在其他微信号上登录，如果继续，所有学习数据会被清除，确认继续登陆吗？</div>
	<div class="model_btn clearfix"><button class="submitBtn_4 fontSize16 lineHeight24 fl" (click)="cancel()">退出</button><button class="submitBtn_3 fontSize16 lineHeight24 fr" (click)="loginAgainPhone()">继续登录</button></div>
</div>

				<div class="logo_img_div">
				<img src="../../assets/picture/learningmap/logo_dark.png" alt="" class="" />
				</div>
				<!-- 手机号码登录 -->
				<div class="signInform signInPhone" *ngIf="_signInPhone">
					<div class="tab_word fontSize12 lineHeight24" id="title_3">

					</div>
					<div id="tab_1_Phone" class="input_wrap">
						<input type="text" placeholder="请输入手机号" autocomplete="off" (blur)="click_blur()" maxlength="14" (focus)="onFocus('tab_1_Phone_input')" class="input_text fontSize16" data-target="phone" id="tab_1_Phone_input" [(ngModel)]="phone_1" name="phone" required />
					</div>
					<div class="errorTxt phoneValidateTxt">请填写手机号码</div>
					<!-- <div class="validateTxt phoneValidateTxt">请填写手机号码</div> -->
					<div id="tab_1_verification" class="input_wrap">
						<input type="text" placeholder="请输入验证码" autocomplete="off" (blur)="click_blur()" maxlength="6" class="input_text fontSize16" id="tab_1_verification_input"   (focus)="onFocus('tab_1_verification_input')" data-target="smsCode" [(ngModel)]="verification_code_1" name="verification_code" required />
						<span id="tab_1_verification_send_out" class="fontSize14 send_out" (click)="sendCode(true)">
							<span class="send_out_word" id="tab_1_verification_send_out_word">获取验证码</span><span class="remainTime" id="tab_1_verification_send_out_remain_time"></span>
						</span>
					</div>
					<div class="errorTxt smsCodeValidateTxt">请填写手机验证码</div>
					<!-- <div class="validateTxt smsCodeValidateTxt">请填写手机验证码</div> -->
					<button class="submitBtn_3 fontSize16 lineHeight24" (click)="loginPhone()"  [ngClass]="{'Btn_disable': !phone_1 || !verification_code_1}" [disabled]="!phone_1 || !verification_code_1">登&nbsp;&nbsp;录</button>
					<div class="tab_word2 fontSize12 lineHeight24"><span (click)="signInPhone()">使用账号登录 ></span></div>
				</div>
				<!-- 账号登录 -->
				<div class="signInform signInNumber" *ngIf="_signInNumber">
					<div class="tab_word fontSize12 lineHeight24" id="title_3">
						如公司已购买账户，请登陆
					</div>
					<div id="tab_1_Number" class="input_wrap">
						<input type="text" placeholder="请输入账号" autocomplete="off" maxlength="256" (blur)="click_blur()" (focus)="onFocus('tab_1_Number_input')" class="input_text fontSize16" data-target="Number" id="tab_1_Number_input" [(ngModel)]="Number_1" name="Number" required />
					</div>
					<div class="errorTxt NumberValidateTxt">请填写账号</div>
					<!-- <p class="validateTxt NumberValidateTxt">请填写账号</p> -->
					<div id="tab_1_Pwd" class="input_wrap">
						<input type="password" placeholder="请输入密码" autocomplete="off" maxlength="200" (blur)="click_blur()" class="input_text fontSize16" id="tab_1_Pwd_input"   (focus)="onFocus('tab_1_Pwd_input')" data-target="smsPwd" [(ngModel)]="verification_Pwd_1" name="verification_Pwd" required />
					</div>
					<div class="errorTxt PwdTxt">请填写账号密码</div>
					<!-- <p class="validateTxt PwdTxt">请填写账号密码</p> -->
					<button class="submitBtn_3 fontSize16 lineHeight24" (click)="loginPwd()" [ngClass]="{'Btn_disable': !Number_1 || !verification_Pwd_1}" [disabled]="!Number_1 || !verification_Pwd_1">登&nbsp;&nbsp;录</button>
					<div class="tab_word2 fontSize12 lineHeight24"><span (click)="signInNumber()">使用手机号码登录 ></span></div>
				</div>

			</div>
      <!-- 2019-9-4 企业员工可以通过员工号密码登录学习 end-->


			<div id="mengban" >
        <div id="baikuang">
          <p class="fontSize14">您还没有绑定任何账户</p>
          <button class="fontSize16" id="shiyong" (click)="shiyong()">申请试用</button>
        </div>
        <div id="closeBtn" (click)="closeTip()">
        </div>
      </div>
    </div>
  </form>
</div>


<div id="shade" (click)="onShadeClick()"></div>

<div id="choice">
  <ul>
    <li *ngFor="let option of options" class="choiceItem fontSize14" (click)="onChoiceClick(option)">
      {{option}}
    </li>
  </ul>
</div>

<div id="tip" class="fontSize14"></div>



// WEBPACK FOOTER //
// ./src/app/activity-form/activity-form.component.html